export default "/build/images/ap.png?363e97acd7a3f5103df2335054a8b42d";